import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DateConvertService {

    constructor() { }
    /* #region  currentDateTimeUTC */
    public currentDateTimeUTC() {
        return new Date(new Date().getTime());
    }
    /* #endregion */

    /* #region  convertToUTC */
    public convertToUTC(dateTime: Date) {
        return new Date(new Date(dateTime).getTime());
    }
    /* #endregion */

    /* #region  convertToLocalDate */
    public convertToLocalDate(utc: Date) {
        const dateValue = new Date(utc);
        const timezoneOffset = dateValue.getTimezoneOffset() * 60 * 1000;
        const utcTime = dateValue.getTime();
        const localTime = utcTime - timezoneOffset;

        return new Date(localTime);
    }
    /* #endregion */
}
